<script lang="ts">
    import {page} from "$app/stores";
    import {
        FileImageOutline,
        FileOutline,
        FilePdfOutline,
        FilePdfSolid,
        FileSolid,
        FileWordOutline,
        FileWordSolid
    } from "flowbite-svelte-icons";
    import convertPdfToImage from "$lib/utils/convertPdfToImage";
    import {Button, Modal, Tooltip} from "flowbite-svelte";
    import {onMount} from "svelte";

    export let value;

    let lightbox = false;
    export let onClick = () => {
        console.log('click')
        lightbox = true;
    }

    $: extension = value.split('.')[value.split('.').length - 1]


    let previews = [];

    const renderPdf = async () => {
        (await convertPdfToImage(value)).forEach((preview) => {
            previews = [...previews, preview]
        })
    }
    onMount(() => {

    })

</script>


<div class="space-y-1" on:click={() => onClick()}>
    {#if extension === 'pdf'}
        <FilePdfOutline class="h-8 w-8" />
    {:else if extension === 'doc' || extension === 'docx'}
        <FileWordOutline  class="h-8 w-8"/>
    {:else if extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'gif'}
        <FileImageOutline class="h-8 w-8"/>
        <Tooltip type="custom" class="p-1 bg-white dark:bg-gray-800">
            <img src={value} alt="image" class="max-h-12 max-w-14 object-cover" />
        </Tooltip>

    {:else}
        <FileOutline class="h-8 w-8" />
    {/if}
</div>
<Modal title="Document" bind:open={lightbox}>
    {#each previews as preview}
        <img src={preview} alt="image">
    {/each}

    {#if extension === 'jpg' || extension === 'png' || extension === 'jpeg' || extension === 'gif'}
        <img src={value} alt="image" class="max-h-96 max-w-full object-cover"/>
    {:else if extension === 'pdf'}
        <div class="flex justify-between">
            <Button on:click={renderPdf}><FilePdfOutline class="h-8 w-8" /> Preview</Button>
            <Button href={value} target="_blank"><FileOutline class="h-8 w-8" /> Download</Button>
        </div>
    {:else}

    {/if}
</Modal>


